


















































import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { get } from "../../services/webclient/webclient";
import $ from "jquery";
import "./_partners-map.less";
import loader from "../loader/loader.vue";
require("./partners.js");
import { translate } from "../../services/translation/translation";

@Component({
  components: {
    loader
  }
})
export default class partnersMap extends Vue {
  private data: any = {
    System: [],
    loading: true
  };

  @Prop() setting;

  mounted() {
    $("body").trigger("click");
  }
  created() {
    window.addEventListener("click", this.showWindow);
  }

  trans(key) {
    return translate(key);
  }

  showWindow() {
    this.selectedPertners((window as any).selectedPartnersId);
  }

  @Emit("selectedPertners")
  selectedPertners(systemId) {}
}
